import React from 'react';
import PropTypes from 'prop-types';
import { ComponentLoader } from '../../../global/ComponentLoader/ComponentLoader';

const importFunc = () => {
    return import(/* webpackChunkName: "SendToFriendModal" */
    'dibs-send-to-friend-modal').then(exported => exported.default);
};

export function PdpSharedSendToFriendModalLoader(props) {
    return <ComponentLoader {...props} load={props.modalOpen} importFunc={importFunc} />;
}

PdpSharedSendToFriendModalLoader.propTypes = {
    modalOpen: PropTypes.bool.isRequired,
};
